import { Box } from "@mui/material";
import LoadingIcon from "./LoadingIcon";

const PopupLoading = () => {
    return (
        <Box
            justifyContent="center"
            alignItems="center"
            display="flex"
            height="250px"
        >
            <LoadingIcon />
        </Box>
    );
};

export default PopupLoading;
